import { ContentWrapper } from '@/components/_common';
import { TransactionType } from '@/core/domain/financial/BankConciliation/BankConciliation.types';
import { useBankConciliationContext } from '@/pages/FinancialPages/BankConciliationPage';
import { Col, Radio, Row } from 'antd';
import TransactionsList from './TransactionsList';

export default function BankConciliationTransactionsCard() {
  const { transactionType, setTransactionType, setTransactionSelected } =
    useBankConciliationContext();

  return (
    <ContentWrapper width="100%" style={{ padding: 12 }}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Radio.Group
            buttonStyle="solid"
            defaultValue="correspondingAccount"
            style={{ display: 'flex', justifyContent: 'center' }}
            value={transactionType}
            onChange={({ target }) => {
              setTransactionType(target.value);
              setTransactionSelected(undefined);
            }}
          >
            <Radio.Button value={TransactionType.credit}>Entradas</Radio.Button>

            <Radio.Button value={TransactionType.debit}>Saídas</Radio.Button>
          </Radio.Group>
        </Col>

        <Col span={24}>
          <TransactionsList />
        </Col>
      </Row>
    </ContentWrapper>
  );
}
